import { appInfoSelector } from '@common/redux/selectors/app';
import React from 'react';
import { useSelector } from 'react-redux';
const libraries = require('@nocode/page-templates');

// MIK-2733
const PageComponent: React.FC<{
  componentName: string | number;
}> = (props) => {
  const appInfo = useSelector(appInfoSelector);
  const Component = libraries[props.componentName];

  if (!Component) {
    return <></>;
  }

  return <Component {...props} brandAssets={appInfo?.brandAssets} />;
};

export default PageComponent;
